import $ from 'jquery';

$(function () {

    $('.contact-form-job').each(function () {
        const $element = $(this);
        const $instantContainer = $element.find('.contact-form-instant-container');


        if (!$element.find('.is-invalid').length
            && !$element.find('.form-success-message').length){
            // Initially hide
            $instantContainer.hide();
        }

        // Handle click and toggle
        $element.find('.action-toggle-instant-container').on('click', function () {
            $instantContainer.slideToggle();
        });
    });


});
